"use strict";

export var D5TableConstants = {
  D5_TABLE_FORM_SET_TITLE: 'D5_TABLE_FORM_SET_TITLE',
  D5_TABLE_FORM_DESTROY_TABLE: 'D5_TABLE_FORM_DESTROY_TABLE',
  D5_TABLE_FORM_SET_TABLE_ELEM: 'D5_TABLE_FORM_SET_TABLE_ELEM',
  D5_TABLE_FORM_INIT: 'D5_TABLE_FORM_INIT',
  D5_TABLE_FORM_REFRESH: 'D5_TABLE_FORM_REFRESH',
  D5_TABLE_DELETE_ROWS: 'D5_TABLE_DELETE_ROWS',
  D5_TABLE_FILTER_SAVED: 'D5_TABLE_FILTER_SAVED',
  D5_TABLE_UPDATE_FORM_UUID: 'D5_TABLE_UPDATE_FORM_UUID',
  D5_TABLE_FOCUS_LAST_ROW: 'D5_TABLE_FOCUS_LAST_ROW',
  D5_TABLE_USER_EVENT: 'D5_TABLE_USER_EVENT',
  D5_TABLE_ON_MASTER_CHANGED: 'D5_TABLE_ON_MASTER_CHANGED',
  D5_SEND_NESTED_DATA: 'D5_SEND_NESTED_DATA',
  D5_TABLE_UPDATE_FILTER_SUBFORM: 'D5_TABLE_UPDATE_FILTER_SUBFORM',
  D5_TABLE_EXPORT: 'D5_TABLE_EXPORT',
  D5_UPDATE_LAYOUT_FILTER: 'D5_UPDATE_LAYOUT_FILTER',
  D5_TABLE_FOCUS_LAST_ROW_FULL: 'D5_TABLE_FOCUS_LAST_ROW_FULL',
  D5_TABLE_RESET_SCROLL: 'D5_TABLE_RESET_SCROLL'
};